var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4933 4.38682C21.4933 3.86253 21.0683 3.4375 20.544 3.4375H3.45616C2.93186 3.4375 2.50684 3.86253 2.50684 4.38682V15.7787C2.50684 16.303 2.93186 16.728 3.45616 16.728H20.544C21.0683 16.728 21.4933 16.303 21.4933 15.7787V4.38682ZM21.4933 19.576C21.4933 19.3139 21.2808 19.1014 21.0187 19.1014H2.9815C2.71935 19.1014 2.50684 19.3139 2.50684 19.576V20.5253C2.50684 20.7875 2.71935 21 2.9815 21H21.0187C21.2808 21 21.4933 20.7875 21.4933 20.5253V19.576Z",
    fill: "#F53F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 9.44114L10.0591 7.5L9.00033 8.55881L10.9414 10.4999L9 12.4414L10.0588 13.5002L12.0001 11.5588L13.9412 13.4999L14.9999 12.4411L13.0589 10.4999L14.9996 8.55911L13.9409 7.5003L12.0001 9.44114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShare);
export default __webpack_public_path__ + "static/media/NoShare.2ef173bb42ec86561a46981d0586858b.svg";
export { ForwardRef as ReactComponent };